// @flow
import React, { Component } from "react";
import { Button, Checkbox, Form, Icon, Label, Modal } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

import BrandSettingsFields from "./BrandSettingsFields";
import { UserInput } from "../../components";

class BrandGroupDetail extends Component {
  state = {
    group: {
      ...this.props.group,
      servicebox_wo_2: this.props.group.servicebox_wo_2 || "",
      servicebox_wo_2_name: this.props.group.servicebox_wo_2_name || "",
    },
    photo: "",
    errorNameText: "",
    errorServiceButtonTabletURL: "",
  };

  handleChange = event => {
    const { name, value } = event.target;
    this.setState(({ group }) => ({ group: { ...group, [name]: value } }));
  };

  handleCheckboxChange = (_, { name, checked }) => {
    this.setState(({ group }) => ({ group: { ...group, [name]: checked } }));
  };

  handleLogoFileChange = event => {
    if (!event || !event.target || !event.target.files) {
      return;
    }
    this.setState({ photo: event.target.files[0] });
  };

  handleChangeComplete = color => {
    this.setState(({ group }) => ({ group: { ...group, color: color.hex } }));
  };

  validateForm = () => {
    let { group } = this.state;

    let errorNameText = "";
    let errorServiceboxWoText = "";
    let errorServiceboxWo2Text = "";
    let errorServiceboxVinText = "";
    let errorServiceButtonTabletURL = "";
    let urlRegex = /^https?:\/\/[a-z0-9]+([-.][a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)*$/;

    if (!group.name || !group.name.trim()) {
      errorNameText = this.props.t("this_field_is_required").message || "This field is required";
    }
    if (!errorNameText && (this.props.brandGroups || []).some(option => option.id !== group.id && option.name.trim().toLowerCase() === group.name.trim().toLowerCase())) {
      errorNameText = this.props.t("group_already_exists").message || "Group already exists";
    }
    if (group.servicebox_wo) {
      if (!urlRegex.test(group.servicebox_wo)) {
        errorServiceboxWoText = this.props.t("enter_valid_url").message || "Enter valid URL";
      }
    }
    if (group.servicebox_wo_2) {
      if (!urlRegex.test(group.servicebox_wo_2)) {
        errorServiceboxWo2Text = this.props.t("enter_valid_url").message || "Enter valid URL";
      }
    }
    if (group.servicebox_vin) {
      if (!urlRegex.test(group.servicebox_vin)) {
        errorServiceboxVinText = this.props.t("enter_valid_url").message || "Enter valid URL";
      }
    }
    if (group.tablet_service_button_url) {
      if (!urlRegex.test(group.tablet_service_button_url)) {
        errorServiceButtonTabletURL = this.props.t("enter_valid_url").message || "Enter valid URL";
      }
    }

    this.setState({
      errorNameText,
      errorServiceboxWoText,
      errorServiceboxWo2Text,
      errorServiceboxVinText,
      errorServiceButtonTabletURL,
    });
    return (
      errorNameText.length === 0 &&
      errorServiceboxWoText.length === 0 &&
      errorServiceboxWo2Text.length === 0 &&
      errorServiceboxVinText.length === 0 &&
      errorServiceButtonTabletURL.length === 0
    );
  };

  handleSave = () => {
    let { group, photo } = this.state;
    if (this.validateForm()) {
      this.props.onSave({ ...group, name: group.name.trim() }, photo);
    }
  };

  render() {
    let { group, errorNameText, errorServiceboxWoText, errorServiceboxWo2Text, errorServiceboxVinText, errorServiceButtonTabletURL } = this.state;

    return (
      <div className="BrandGroupDetail">
        <Modal
          open={true}
          onClose={() => {
            this.props.onHideDetail();
          }}
          closeOnDimmerClick={false}
          size="small"
        >
          <Modal.Header className="brand-detail-modal-header">
            {this.props.mode === "create" ? this.props.t("add_new_group").message || "Add new group" : this.props.t("edit_group").message || "Edit group"}
            <Checkbox
              name="is_active"
              floated="right"
              checked={group.is_active}
              onChange={this.handleCheckboxChange}
              label={this.props.t("active").message || "Active"}
            />
          </Modal.Header>

          <Modal.Content scrolling>
            <Form>
              <Form.Field>
                <label>{this.props.t("group").message || "Group"}</label>
                <UserInput type="text" name="name" onChange={this.handleChange} placeholder={this.props.t("group").message || "Group"} value={group.name} />
                {errorNameText && (
                  <Label basic color="red" pointing>
                    {errorNameText}
                  </Label>
                )}
              </Form.Field>
              <BrandSettingsFields
                values={group}
                errors={{ errorServiceButtonTabletURL, errorServiceboxWoText, errorServiceboxVinText, errorServiceboxWo2Text }}
                onChange={this.handleChange}
                onColorChange={this.handleChangeComplete}
                onFileChange={this.handleLogoFileChange}
              />
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color="red"
              disabled={this.props.loading}
              onClick={() => {
                this.props.onHideDetail();
              }}
              floated="left"
            >
              <Icon name="close" /> {this.props.t("discard").message || "DISCARD"}
            </Button>
            <Button color="green" onClick={this.handleSave} loading={this.props.loading} disabled={this.props.loading}>
              <Icon name="checkmark" /> {this.props.t("save").message || "SAVE"}
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default withTranslation()(BrandGroupDetail);
